import { apiRestApi } from "Services/restApi";

import type { ListBrandSecretsResponse } from "Services/BrandSecrets/BrandSecretsApiService";

export const BrandSecretsApiTag = {
    BrandSecretList: "BrandSecretList",
} as const;

const brandSecretsApiWithTags = apiRestApi.enhanceEndpoints({
    addTagTypes: Object.values(BrandSecretsApiTag),
});

export const brandSecretsApi = brandSecretsApiWithTags.injectEndpoints({
    endpoints: (builder) => ({
        listBrandSecrets: builder.query<ListBrandSecretsResponse, void>({
            query: () => ({ endpoint: "/brand-secrets" }),
            providesTags: [{ type: BrandSecretsApiTag.BrandSecretList }],
        }),
    }),
});

export const { useListBrandSecretsQuery } = brandSecretsApi;
